import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ResolveUnableToTwoWaySyncModal,
  type ResolveUnableToTwoWaySyncModalProps,
} from './resolveUnableToTwoWaySyncModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ResolveUnableToTwoWaySync: Omit<ResolveUnableToTwoWaySyncModalProps, 'isOpen' | 'onClose'>;
  }
}

modalRenderer.register('ResolveUnableToTwoWaySync', (props) => <ResolveUnableToTwoWaySyncModal {...props} />);
